import React from 'react'
import Layout from '../../../Layout'
import EditDeliveryContainer from '../../../../../Components/UserPart/EditUser/Delivery/EditDeliveryContainer'

const EditDriver = () => {
  return (
    <Layout>
        <EditDeliveryContainer/>
    </Layout>
  )
}

export default EditDriver